module.exports = __webpack_public_path__ + "static/media/female4.043c7f00.png";


//////////////////
// WEBPACK FOOTER
// ./src/modules/assets/body-model/female4.png
// module id = 901
// module chunks = 0